<template>
  <section id="members" class="section-padding fade-in-up">
    <div class="container">
      <!-- 大白色圆角容器 -->
      <div class="member-module-container">
        <div class="text-center mb-4">
          <h2 class="section-title">会员风采</h2>
          <div class="section-divider w-20 mx-auto"></div>
        </div>

        <!-- 按钮组 -->
        <div class="flex items-center justify-center space-x-4 mb-6">
          <button
            :class="activeTab === 'council'
              ? 'bg-blue-600 text-white border border-blue-600'
              : 'bg-white text-blue-600 border border-blue-600'"
            class="tab-btn px-6 py-2 rounded-full text-sm"
            @click="switchTab('council')">理事单位</button>
          <button
            :class="activeTab === 'new'
              ? 'bg-blue-600 text-white border border-blue-600'
              : 'bg-white text-blue-600 border border-blue-600'"
            class="tab-btn px-6 py-2 rounded-full text-sm"
            @click="switchTab('new')">新会员单位</button>
        </div>

        <!-- 理事单位 -->
        <div class="mb-10 text-center" v-show="activeTab === 'council'">

          <div v-if="loading" class="flex justify-center items-center py-12">
            <div class="text-gray-600">加载中...</div>
          </div>
          <div v-else-if="councilMembers.length === 0" class="flex justify-center items-center py-12">
            <div class="text-gray-600">暂无理事单位数据</div>
          </div>
          <div v-else class="flex items-center">
            <div v-if="currentPage > 1" @click="prevPage" class="bg-transparent border-none p-2 focus:outline-none cursor-pointer">
              <img src="../assets/images/qianxleft.png" alt="上一页" class="w-6 h-12">
            </div>
            <div v-else class="w-8"></div>
            <div class="flex-1">
              <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 justify-center max-w-6xl mx-auto">
                <div
                  v-for="(member, index) in councilMembers"
                  :key="'council-' + index"
                  class="member-card cursor-pointer"
                  @click="viewMemberDetail(member.companyId)"
                >
                  <div class="member-logo">
                    <img v-if="member.icon !== ''" :src="getFullImageUrl(member.icon)" :alt="member.title" class="w-full h-full object-cover" loading="lazy">
                    <img v-else src="../assets/companyLogo.jpg" :alt="member.title" class="w-full h-full object-cover" loading="lazy">
                  </div>
                  <h3>{{ member.title }}</h3>
                </div>
              </div>
            </div>
            <div v-if="!isLastPage" @click="nextPage" class="bg-transparent border-none p-2 focus:outline-none cursor-pointer">
              <img src="../assets/images/qianxr.png" alt="下一页" class="w-6 h-12">
            </div>
            <div v-else class="w-8"></div>
          </div>
        </div>

        <!-- 新会员单位 -->
        <div class="mb-8 text-center" v-show="activeTab === 'new'">

          <div v-if="loading" class="flex justify-center items-center py-12">
            <div class="text-gray-600">加载中...</div>
          </div>
          <div v-else-if="newMembers.length === 0" class="flex justify-center items-center py-12">
            <div class="text-gray-600">暂无新会员单位数据</div>
          </div>
          <div v-else class="flex items-center">
            <div v-if="currentPage > 1" @click="prevPage" class="bg-transparent border-none p-2 focus:outline-none cursor-pointer">
              <img src="../assets/images/qianxleft.png" alt="上一页" class="w-6 h-12">
            </div>
            <div v-else class="w-8"></div>
            <div class="flex-1">
              <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 justify-center max-w-6xl mx-auto">
                <div
                  v-for="(member, index) in newMembers"
                  :key="'new-' + index"
                  class="member-card cursor-pointer"
                  @click="viewMemberDetail(member.companyId)"
                >
                  <div class="member-logo">
                    <img v-if="member.icon !== ''" :src="getFullImageUrl(member.icon)" :alt="member.title" class="w-full h-full object-cover" loading="lazy">
                    <img v-else src="../assets/companyLogo.jpg" :alt="member.title" class="w-full h-full object-cover" loading="lazy">
                  </div>
                  <h3>{{ member.title }}</h3>
                </div>
              </div>
            </div>
            <div v-if="!isLastPage" @click="nextPage" class="bg-transparent border-none p-2 focus:outline-none cursor-pointer">
              <img src="../assets/images/qianxr.png" alt="下一页" class="w-6 h-12">
            </div>
            <div v-else class="w-8"></div>
          </div>
        </div>

        <!-- 查看更多按钮 -->
<!--        <div class="text-center" v-if="showViewMoreButton">-->
<!--          <button class="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors" @click="viewMoreMembers">-->
<!--            查看更多 >>-->
<!--          </button>-->
<!--        </div>-->
      </div>
    </div>
  </section>
</template>

<script>
import { api } from '../api'
import { CURRENT_CONFIG } from '../api/config';
export default {
  name: 'MemberSection',
  data() {
    return {
      loading: false,
      councilMembers: [],
      newMembers: [],
      showViewMoreButton: false,
      BASE_URL: CURRENT_CONFIG.BASE_URL,
      activeTab: 'council', // 'council' 或 'new'
      currentPage: 1,
      pageSize: 8,
      councilTotal: 0,
      newTotal: 0
    }
  },
  computed: {
    isLastPage() {
      if (this.activeTab === 'new') {
        return this.currentPage * this.pageSize >= this.newTotal
      } else {
        return this.currentPage * this.pageSize >= this.councilTotal
      }
    }
  },
  async mounted() {
    await this.loadMembersDirector()
  },
  methods: {
    async loadMembersNew() {
      this.loading = true
      try {
        // 调用API获取会员数据
        const result = await api.getMembersNew(this.currentPage)
        this.newMembers = result.newMembersData.rows.map(member => ({
          id: member.id,
          icon: member.companyLogo ? member.companyLogo : '',
          title: member.companyName,
          companyId: member.companyId
        }))
        this.newTotal = result.newMembersData.total
      } catch (error) {
        console.error('加载会员数据失败:', error)
        // 加载失败时使用默认数据
        this.newMembers = []
      } finally {
        this.loading = false
      }
    },
    async loadMembersDirector() {
      this.loading = true
      try {
          // 调用API获取会员数据
          const result = await api.getMembersDirector(this.currentPage)
          this.councilMembers = result.councilMembersData.rows.map(member => ({
            id: member.id,
            icon: member.companyLogo ? member.companyLogo : '',
            title: member.companyName,
            companyId: member.companyId
          }))
          this.councilTotal = result.councilMembersData.total
      } catch (error) {
          console.error('加载会员数据失败:', error)
          // 加载失败时使用默认数据
          this.councilMembers = []
      } finally {
          this.loading = false
      }
  },
    viewMoreMembers() {
      // 跳转到会员列表页面
      this.$router.push('/members')
    },
    getFullImageUrl(path) {
      if (!path) return ''
      // 如果已经是完整链接(http开头)，直接返回
      if (path.startsWith('http')) return path
      // 否则拼接环境变量中的基地址
      return this.BASE_URL + path
    },
    switchTab(tab) {
      this.activeTab = tab
      this.currentPage = 1
      if (tab === 'new' && this.newMembers.length === 0) {
        this.loadMembersNew()
      } else if (tab === 'council' && this.councilMembers.length === 0) {
        this.loadMembersDirector()
      }
    },
    viewMemberDetail(companyId) {
      this.$router.push(`/member-detail/${companyId}`)
    },
    async nextPage() {
      this.currentPage++
      if (this.activeTab === 'new') {
        await this.loadMembersNew()
      } else {
        await this.loadMembersDirector()
      }
    },
    async prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
        if (this.activeTab === 'new') {
          await this.loadMembersNew()
        } else {
          await this.loadMembersDirector()
        }
      }
    }
  }
}
</script>

<style scoped>
/* 背景色设置 */
.section-padding {
  background-color: var(--bg);
  position: relative;
  overflow: hidden;
  padding: 16px 0;
}

.section-padding::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at 50% 50%, rgba(96, 165, 250, 0.1) 0%, transparent 70%);
  pointer-events: none;
  z-index: 0;
}

/* 内容容器 */
.container {
  position: relative;
  z-index: 1;
}

/* 大白色圆角容器 */
.member-module-container {
  background: #ffffff;
  border-radius: 32px;
  box-shadow: 0 20px 40px -15px rgba(37,99,235,0.08);
  padding: 48px 40px;
  margin-bottom: 0;
  border: 1px solid rgba(37,99,235,0.12);
}

/* 蓝色分隔线样式 */
.section-divider {
  height: 2px;
  background: linear-gradient(90deg, transparent, var(--accent), transparent);
  margin: 1rem auto;
  box-shadow: 0 0 10px rgba(96, 165, 250, 0.5);
}

/* 滚动容器样式 */
.scroll-container {
  display: flex;
  animation: scroll 30s linear infinite;
}

/* 滚动动画 */
@keyframes scroll {
  0% {
    /*transform: translateX(0);*/
  }
  100% {
    /*transform: translateX(-50%);*/
  }
}

/* 滚动容器包装器 */
.scroll-wrapper {
  width: 100%;
  overflow: hidden;
  white-space: normal;
  margin-bottom: 32px;
  position: relative;
}

/* 隐藏滚动条 */
.scroll-container::-webkit-scrollbar {
  display: none;
}

.scroll-container {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

/* 会员卡片样式 */
.member-card {
  flex-shrink: 0;
  text-align: center;
  padding: 24px 20px;
  background: #ffffff;
  border-radius: 32px;
  box-shadow: 0 4px 12px rgba(37,99,235,0.08);
  border: 1px solid rgba(37,99,235,0.12);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
}

.member-card:hover {
  /*transform: translateY(-4px);*/
  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.15);
  border-color: rgba(96, 165, 250, 0.3);
}

/* Logo容器 */
.member-logo {
  width: 80px;
  height: 80px;
  border-radius: var(--radius-lg);
  background: var(--surface);
  margin: 0 auto 16px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.1);
}

.member-card:hover .member-logo {
  /*transform: scale(1.05);*/
  box-shadow: 0 0 15px rgba(96, 165, 250, 0.3);
}

.member-logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.member-card:hover .member-logo img {
  transform: scale(1.05);
}

/* 企业名称 */
.member-card h3 {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 8px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  min-height: 2.5em;
  color: var(--text-primary);
  transition: color 0.3s ease;
}

.member-card:hover h3 {
  color: var(--accent);
}

/* 按钮样式 */
button.bg-blue-600 {
  background: linear-gradient(135deg, var(--accent), var(--accent-light));
  color: white;
  border: none;
  border-radius: 50px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 15px rgba(37, 99, 235, 0.3);
  position: relative;
  overflow: hidden;
}

button.bg-blue-600:hover {
  /*transform: translateY(-2px);*/
  box-shadow: 0 6px 20px rgba(37, 99, 235, 0.4);
  animation: breathe 2s ease-in-out infinite;
}

/* Tab 按钮：取消动效，保持简洁 */
.tab-btn {
  transition: none !important;
  animation: none !important;
  box-shadow: none !important;
  border-radius: 9999px !important;
}

.tab-btn.bg-blue-600 {
  background: #2563eb !important;
  border: 1px solid #2563eb !important;
  padding: 8px 24px !important;
}

.tab-btn:hover {
  animation: none !important;
  transform: none !important;
}

/* 查看更多按钮 */
.text-center button {
  background: linear-gradient(135deg, var(--accent), var(--accent-light));
  color: white;
  border: none;
  border-radius: 50px;
  padding: 12px 32px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 15px rgba(37, 99, 235, 0.3);
  position: relative;
  overflow: hidden;
}

.text-center button:hover {
  /*transform: translateY(-2px);*/
  box-shadow: 0 6px 20px rgba(37, 99, 235, 0.4);
  animation: breathe 2s ease-in-out infinite;
}

/* 加载和空状态 */
.flex.justify-center div {
  color: var(--text-secondary);
}

/* 呼吸动画 */
@keyframes breathe {
  0%, 100% {
    box-shadow: 0 6px 20px rgba(37, 99, 235, 0.4);
  }
  50% {
    box-shadow: 0 8px 25px rgba(37, 99, 235, 0.6);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .section-padding {
    padding: 48px 0;
  }

  .member-card {
    width: 200px;
    padding: 24px 20px;
    border-radius: 24px;
  }

  .member-logo {
    width: 60px;
    height: 60px;
  }

  .member-card h3 {
    font-size: 0.875rem;
  }
}

@media (max-width: 480px) {
  .member-card {
    width: 160px;
    padding: 16px 12px;
    border-radius: 16px;
  }

  .member-logo {
    width: 50px;
    height: 50px;
  }

  .scroll-wrapper {
    padding: 16px;
  }
}
</style>
